import gettext from 'js-utils/gettext';
import PropTypes from 'prop-types';
import { LOCALES_ARRAY_PROP_TYPE, LOCALE_INFO_SHAPE_PROP_TYPE, HELP_LINKS_PROP_TYPE } from '@eb/site-footer';
var HEADER_ORGANIZE_LINKS_PROP_TYPE = PropTypes.shape({
  home: PropTypes.shape({
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    gaLabel: PropTypes.string
  }).isRequired,
  suggested: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    gaLabel: PropTypes.string
  })).isRequired
});
export var ENV_SHAPE_PROP_TYPE = PropTypes.shape({
  serverUrl: PropTypes.string.isRequired,
  ebDomain: PropTypes.string.isRequired,
  adminServerUrl: PropTypes.string.isRequired,
  signupUrl: PropTypes.string.isRequired,
  loginUrl: PropTypes.string.isRequired,
  logoutUrl: PropTypes.string.isRequired,
  searchLocation: PropTypes.string.isRequired,
  locales: LOCALES_ARRAY_PROP_TYPE.isRequired,
  localeInfo: LOCALE_INFO_SHAPE_PROP_TYPE.isRequired,
  helpUrls: HELP_LINKS_PROP_TYPE.isRequired,
  organizeUrls: HEADER_ORGANIZE_LINKS_PROP_TYPE.isRequired,
  searchQuery: PropTypes.string,
  isNewAccountSettingsActive: PropTypes.bool
});
export var REQUEST_SHAPE_PROP_TYPE = PropTypes.shape({
  path: PropTypes.string.isRequired
});
export var USER_SHAPE_PROP_TYPE = PropTypes.shape({
  canInvite: PropTypes.bool,
  canCreateEvents: PropTypes.bool,
  firstName: PropTypes.string,
  fullName: PropTypes.string,
  hasEvents: PropTypes.bool,
  hasOrganizers: PropTypes.bool,
  hasTikibar: PropTypes.bool,
  isAttendee: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  isStaff: PropTypes.bool,
  numOrders: PropTypes.number,
  numSavedEvents: PropTypes.number,
  publicId: PropTypes.string,
  thumbnailUrl: PropTypes.string,
  numFollowing: PropTypes.number
});
export var SUGGESTIONS_API_URL = '/directory/autocomplete/';
export var DEFAULT_LOCATION = 'Current Location';
export var SUGGESTIONS_RESPONSE_GROUPS = ['top_match', 'events', 'organizers', 'categories', 'popular_queries'];
export var FALLBACK_CATEGORIES = [{
  type: 'Category',
  category: gettext('Categories'),
  label: gettext('Arts'),
  source: 'autocomp',
  url: '/d/local/arts--events/',
  value: 'Arts'
}, {
  type: 'Category',
  category: gettext('Categories'),
  label: gettext('Business'),
  source: 'autocomp',
  url: '/d/local/business--events/',
  value: 'Business'
}, {
  type: 'Category',
  category: gettext('Categories'),
  label: gettext('Charity & Causes'),
  source: 'autocomp',
  url: '/d/local/charity-and-causes--events/',
  value: 'Charity & Causes'
}, {
  type: 'Category',
  category: gettext('Categories'),
  label: gettext('Community'),
  source: 'autocomp',
  url: '/d/local/community--events/',
  value: 'Community'
}, {
  type: 'Category',
  category: gettext('Categories'),
  label: gettext('Film & Media'),
  source: 'autocomp',
  url: '/d/local/film-and-media--events/',
  value: 'Film & Media'
}, {
  type: 'Category',
  category: gettext('Categories'),
  label: gettext('Food & Drink'),
  source: 'autocomp',
  url: '/d/local/food-and-drink--events/',
  value: 'Food & Drink'
}, {
  type: 'Category',
  category: gettext('Categories'),
  label: gettext('Music'),
  source: 'autocomp',
  url: '/d/local/music--events/',
  value: 'Music'
}, {
  type: 'Category',
  category: gettext('Categories'),
  label: gettext('All Categories'),
  source: 'autocomp',
  url: '/d/local/events/',
  value: 'All Categories'
}];
export var FALLBACK_SUGGESTIONS = FALLBACK_CATEGORIES.map(function (_ref) {
  var label = _ref.label,
      url = _ref.url;
  return {
    content: label,
    value: url
  };
});
export var ACTION_CREATE_ATTEMPT = 'CreateAttempt';
export var ACTION_DISCOVER = 'Discover';
export var ACTION_HELP_ARTICLE = 'HelpArticle';
export var ACTION_LOGIN_ATTEMPT = 'LoginAttempt';
export var ACTION_LOGO_HOME = 'LogoHome';
export var ACTION_PROFILE_DROPDOWN = 'ProfileDropdown';
export var ACTION_LOGOUT = 'Logout';
export var CATEGORY_HEADER = 'header';
export var LABEL_HELP_CENTER = 'HelpCenter';
export var LABEL_ACCOUNT = 'Account';
export var LABEL_MY_CONTACTS = 'My Contacts';
export var LABEL_MY_EVENTS = 'My Events';
export var LABEL_ORGANIZER_PROFILE = 'My Organizer Profile';
export var LABEL_SAVED = 'Saved';
export var LABEL_TICKETS = 'Tickets';
export var LABEL_FOLLOWING = 'Following';
export var LABEL_COLLECTIONS = 'Collections';
export var LABEL_INTERESTS = 'Interests';
export var LABEL_SPONSORSHIPS = 'Sponsorships';
export var LABEL_STUDIO = 'Studio';
export var LABEL_EMAIL_NAME_ACCOUNT = 'EmailAndNameAccount';